import { cn } from 'lib/utils'
import { FormError } from 'components/atoms/FormError'
import type { InputHTMLAttributes } from 'react'

const mainClass = 'form'

export interface InputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'className'
> {
  error?: string
  className?: string
}

export const Input = ({ error, className, ...inputProps }: InputProps) => {
  return (
    <div className={cn(`${mainClass}__group`)}>
      <input
        {...inputProps}
        className={cn(`${mainClass}__control`, className)}
      />
      {error && <FormError message={error} />}
    </div>
  )
}
